import { createFileRoute } from "@tanstack/react-router"
import { queryClient } from "@/queryClient"
import { getAssignmentOptions, listMyReceivedReviewsOptions } from "@/client/@tanstack/react-query.gen"
import StudentFeedback from "@/routes/-pages/StudentFeedback"
import { runBackendModePrefetch } from "@/utils/routePrefetch"

export const Route = createFileRoute("/assessment/$assessmentId/feedback")({
  loader: ({ params }) => {
    const { assessmentId } = params
    return runBackendModePrefetch(() =>
      Promise.all([
        queryClient.prefetchQuery(getAssignmentOptions({ path: { assignment_id: assessmentId } })),
        queryClient.prefetchQuery(listMyReceivedReviewsOptions({ path: { assignment_id: assessmentId } })),
      ]),
    )
  },
  component: StudentFeedback,
})
